var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconArtTypeVideo = function SvgIconArtTypeVideo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2,
    clipPath: "url(#icon_art_type_video_svg__a)",
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.635 8.597c-.1.418-.578.713-1.533 1.303-.922.571-1.384.857-1.756.742a.93.93 0 0 1-.406-.262c-.274-.3-.274-.882-.274-2.046s0-1.747.274-2.047a.9.9 0 0 1 .406-.261c.372-.116.834.17 1.756.741.955.59 1.432.886 1.534 1.303.041.173.041.354 0 .527"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.999 7.333v1c0 2.986 0 4.479-.926 5.406-.928.928-2.42.928-5.406.928s-4.48 0-5.406-.928c-.928-.927-.928-2.42-.928-5.406s0-4.478.928-5.406C3.188 2 4.68 2 7.667 2l1 .001"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12.333 1.334.172.464c.226.61.338.914.56 1.136.223.223.528.335 1.137.56l.465.173-.465.172c-.61.225-.914.338-1.136.56-.223.223-.335.527-.56 1.136L12.332 6l-.172-.465c-.225-.609-.338-.913-.56-1.136s-.527-.335-1.136-.56L10 3.667l.465-.172c.609-.226.914-.338 1.136-.56s.335-.527.56-1.137z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "icon_art_type_video_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  })))));
};
export default SvgIconArtTypeVideo;